module.exports = __webpack_public_path__ + "img/hp-logo.0cacd997.gif";